import { QueryResult } from './../../../../../models/query-result';
import { DateUtil } from '@app/shared/utils/date-util.service';
import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '@app/core/auth/user.service';
import { ReviewService } from '@app/core/services/review.service';
import { Listing } from '@app/models/listing.model';
import { Review } from '@app/models/review.model';
import { User } from '@app/models/user.model';
import { ImageUtil } from '@app/shared/utils/image.util.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take, switchMap } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-listing-reviews',
  templateUrl: './listing-reviews.component.html',
  styleUrls: ['./listing-reviews.component.scss']
})
export class ListingReviewsComponent implements OnInit {
  unsubscribe$ = new Subject();

  @Input() listing: Listing;

  reviewsQueryResult$: Observable<QueryResult<Review[]>>;
  reviewsLoading$ = new BehaviorSubject(true);
  reviewsPagination$ = new BehaviorSubject({ page: 0, size: 12 });
  reviewAnalytics$: Observable<any>;

  reviewUsers: User[] = [];

  constructor(
    private dateUtil: DateUtil,
    private imageUtil: ImageUtil,
    private userService: UserService,
    private reviewService: ReviewService,
  ) { }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit() {
    this.reviewsQueryResult$ = this.reviewsPagination$.pipe(
      switchMap(queryOption => this.reviewService
        .getListingReviewsQueryResult(this.listing.id, queryOption)
      )
    );

    this.reviewsQueryResult$
      .pipe(take(1))
      .subscribe(queryResult => {
        this.reviewsLoading$.next(false);

        queryResult.data.forEach(review => {
          this.userService.getUserDetails(review.userId)
            .pipe(take(1))
            .subscribe(user => this.reviewUsers.push(user));
        });
      });

    this.reviewAnalytics$ = this.reviewService
      .getListingReviewAnalytics(this.listing.id);
  }

  getImageStyle(imageUrl: string): string {
    return this.imageUtil.getBackgroundImageStyle(imageUrl);
  }

  getUserPhotoUrl(review: Review): string {
    const user = this.reviewUsers.find(({ uid }) => uid === review.userId);
    return user ? user.photoURL : '';
  }

  getReviewUserDisplayName(review: Review): string {
    const user = this.reviewUsers.find(({ uid }) => uid === review.userId);
    return user
      ? user.displayName || `${user.firstName} ${user.lastName}`
      : '';
  }

  getReviewDate(review: Review): string {
    const reviewDateFormat = 'MMMM DD, YYYY';
    return `${this.dateUtil.format(review.createdOn.toDate(), reviewDateFormat)}`;
  }

  getReviewComment(review: Review): string {
    return review && review.comment ? `${review.comment}` : '';
  }

  toSignificatFigures(num: number, figures = 1): string {
    return `${(Math.round(num * 100) / 100).toFixed(figures)}`
  }

  getReviewStars(rating: number) {
    const noStar = 'fa fa-star-o';
    const starClass = 'fa fa-star';
    const halfStarClass = `${starClass}-half-o`;
    return [
      noStar,
      noStar,
      noStar,
      noStar,
      noStar
    ]
      .map(
        (item, idx) => rating - idx >= 1
          ? starClass
          : rating - idx > 0
            ? halfStarClass
            : item
      );
  }

  handleReviewPaginatorChange($event: PageEvent) {
    this.reviewsPagination$.next({
      ...this.reviewsPagination$.value,
      page: $event.pageIndex
    })
  }

}
